// extracted by mini-css-extract-plugin
export default {"screen-template":"screen-template__screen-template--tzCSp","screenTemplate":"screen-template__screen-template--tzCSp"};